// pages/PostDetailPage.jsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import usePostDetail from "../hooks/usePostDetail";
import Actions from "../components/Post/Actions";
import FeedContainer from "../components/Feed/FeedContainer";
import SearchPage from "./SearchPage";

export default function PostDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { post, loading, error } = usePostDetail(id);

  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (post) setLinks(post.links || []);
  }, [post]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-white/30 animate-spin" />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="min-h-screen bg-black flex flex-col items-center justify-center gap-4">
        <p className="text-white/40 text-lg">Post not found</p>
        <button
          onClick={() => navigate(-1)}
          className="text-white/60 hover:text-white text-sm underline"
        >
          Go back
        </button>
      </div>
    );
  }

  const postAuthor = post.username || post.author?.username;

  const feedData = {
    username: postAuthor,
    postAuthorId: post.author?.id,
    profile_icon: post.profile_icon,
    profile_id: post.profile_id,
    is_following: post.is_following,
    quote: post.caption,
    chat: "",
  };

  return (
    <div className="bg-black min-h-screen text-white">

      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="fixed top-4 left-4 z-50 bg-white/10 backdrop-blur-sm
          hover:bg-white/20 p-2.5 rounded-full transition-all duration-200"
      >
        <ArrowLeft className="w-5 h-5 text-white" />
      </button>

      {/* Feed Style Layout */}
      <div className="flex lg:flex-row flex-nowrap lg:overflow-hidden
        overflow-x-auto snap-x snap-mandatory scroll-smooth h-screen">

        {/* LEFT — Actions (image + action bar) */}
        <div className="lg:w-1/2 w-full h-screen snap-start shrink-0">
          <div className="h-full bg-black">
            <Actions
              id={post.id}
              image={post.image}
              images={post.images}
              username={post.username}
              caption={post.caption}
              is_liked={post.is_liked}
              likes_count={post.likes_count}
              comment_count={post.comments_count}
              is_bookmarked={post.is_bookmarked}
              postAuthorId={post.author?.id}
              links={links}
            />
          </div>
        </div>

        {/* RIGHT — FeedContainer */}
        <div className="lg:w-1/2 w-full h-screen snap-start shrink-0">
          <div className="h-full overflow-hidden flex justify-center bg-black px-6 pt-6">
            <div className="h-full w-full max-w-xl">
              <FeedContainer {...feedData} />
            </div>
          </div>
        </div>

      </div>

      {/* More to Explore */}
      <div className="mt-8 px-4 pb-8">
        <h2 className="text-white/60 text-xs uppercase tracking-wider mb-4">
          More to explore
        </h2>
        <SearchPage hideSearch={true} />
      </div>

    </div>
  );
}
